import { useMemo, useState } from 'react'

export function useThreadsSectionFilter(threads = []) {
  const [searchValue, setSearchValue] = useState('')

  const filteredThreads = useMemo(() => {
    const q = searchValue.trim().toLowerCase()
    if (!q) return threads
    return threads.filter((thread) => thread.title?.toLowerCase().includes(q))
  }, [threads, searchValue])

  return { searchValue, setSearchValue, filteredThreads }
}
